module.exports = __webpack_public_path__ + "img/ps-34.b089f258.jpg";